import * as THREE from 'three';
import footerFragment from './shaders/footer/fragment.glsl';
import vertexFragment from './shaders/footer/vertex.glsl';

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl');

// Scene
const scene = new THREE.Scene();

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
};

/**
 * FOOTER PARAMS
 */

const footerHeight = sizes.height;

// Position the plane at the end of the scroll for the footer
window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    footer.position.y = scrollY - maxScroll - ((window.innerHeight - footerHeight) / 2);
});

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    // Update the orthographic camera
    const aspect = sizes.width / sizes.height;
    const cameraWidth = sizes.width; // Fixed width of the plane, adjust as needed
    const cameraHeight = cameraWidth / aspect;

    camera.left = -cameraWidth / 2;
    camera.right = cameraWidth / 2;
    camera.top = cameraHeight / 2;
    camera.bottom = -cameraHeight / 2;
    camera.updateProjectionMatrix();

    // Resize footer
    footer.scale.x = sizes.width;
    footer.scale.y = footerHeight;

    // Update uniforms
    footerMaterial.uniforms.u_size.value.set(sizes.width, footerHeight, sizes.width / footerHeight);

    // Position footer on resize
    const scrollY = window.scrollY;
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    footer.position.y = scrollY - maxScroll - ((window.innerHeight - footerHeight) / 2);
});

/**
 * Camera
 */
const camera = new THREE.OrthographicCamera(
    -sizes.width / 2,
    sizes.width / 2,
    sizes.height / 2,
    -sizes.height / 2,
    -1000,
    1000
);
camera.position.set(0, 0, 4);
scene.add(camera);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
});
// Background color
renderer.setClearColor(0x777777);
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Material
 */
const footerMaterial = new THREE.ShaderMaterial({
    side: THREE.DoubleSide,
    fragmentShader: footerFragment,
    vertexShader: vertexFragment,
    uniforms: {
        u_bgColor: new THREE.Uniform(new THREE.Vector3(0.949, 0.949, 0.941)),
        u_sphereCol: new THREE.Uniform(new THREE.Vector3(0.88, 0.88, 0.87)),
        u_size: new THREE.Uniform(new THREE.Vector3(sizes.width, footerHeight, sizes.width / footerHeight)),
        u_pixelRatio: new THREE.Uniform(window.devicePixelRatio),
        u_time: new THREE.Uniform(0),
        u_camDist: new THREE.Uniform(-3),
        u_mouse: new THREE.Uniform(new THREE.Vector3(999, 999, 0)),
    },
});

/**
 * Objects
 */

// Footer plane
const footer = new THREE.Mesh(
    new THREE.PlaneGeometry(1, 1), // Fixed height now
    footerMaterial
);
footer.scale.x = sizes.width;
footer.scale.y = footerHeight;
footer.position.x = 0;
scene.add(footer);

/**
 * Mouse Gesture
 */
// Add Raycaster for mouse interaction
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2(-5, -5);
let prevMouse = new THREE.Vector2(-5, -5);
const smoothFactor = 0.1;

// Handle mouse move to update the raycaster's mouse position
window.addEventListener('pointermove', (event) => {
    // Normalize the mouse position
    mouse.x = (event.clientX / sizes.width) * 2 - 1;
    mouse.y = -(event.clientY / sizes.height) * 2 + 1;
});

/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {
    const elapsedTime = clock.getElapsedTime();
    footerMaterial.uniforms.u_time.value = elapsedTime;

    // Interpolate mouse position between previous and current position
    footerMaterial.uniforms.u_mouse.value.x = prevMouse.x * (1 - smoothFactor) + mouse.x * smoothFactor;
    footerMaterial.uniforms.u_mouse.value.y = prevMouse.y * (1 - smoothFactor) + mouse.y * smoothFactor;

    // Update previous mouse position
    prevMouse.copy(footerMaterial.uniforms.u_mouse.value);

    // Update Raycaster
    raycaster.setFromCamera(footerMaterial.uniforms.u_mouse.value, camera);
    const intersects = raycaster.intersectObject(footer);
    if (intersects.length > 0) {
        const x = intersects[0].uv.x;
        const y = intersects[0].uv.y;
        footerMaterial.uniforms.u_mouse.value.x = x * 2 - 1;
        footerMaterial.uniforms.u_mouse.value.y = y * 2 - 1;
    }

    // Render the scene
    renderer.render(scene, camera);

    // Request the next frame
    window.requestAnimationFrame(tick);
};

tick();
